export const SORT_ORDERS = Object.freeze({
  ASCENDING: 1,
  NONE: 0,
  DESCENDING: -1
})
